import {
  Description,
  Dialog,
  DialogPanel,
  DialogTitle,
} from '@headlessui/react'
import { fetchAuthSession } from 'aws-amplify/auth'
import { Field, Form, Formik } from 'formik'
import { useState } from 'react'
import { useNavigate } from 'react-router'
import { Link } from 'react-router-dom'
import { API, fetchApiCreds } from '../api'

export const NewApiCredentials = () => {
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<any>(null)
  const [error, setError] = useState(null)
  const [isCopied, setIsCopied] = useState(false)

  const navigate = useNavigate()

  const createCredentials = async (values: any) => {
    setLoading(true)
    try {
      const res = await API(await fetchAuthSession()).post('/app', values)
      fetchApiCreds()
      setResponse(res.data)
    } catch (e: any) {
      setError(e?.response?.data?.message)
      setLoading(false)
    }
  }

  const copyToClipboard = () => {
    navigator.clipboard.writeText(JSON.stringify(response))
    setIsCopied(true)
    setTimeout(() => setIsCopied(false), 2000)
  }

  return (
    <div className="w-full flex">
      <Dialog
        open={!!error}
        onClose={() => setError(null)}
        className="relative z-50"
      >
        <div className="fixed inset-0 bg-black/30" />
        <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
          <DialogPanel className="mx-auto w-100 rounded-lg p-10 bg-primary-50">
            <DialogTitle>Error creating credentials</DialogTitle>
            <Description className="py-4">{error}</Description>
          </DialogPanel>
        </div>
      </Dialog>
      <Dialog
        open={!!response}
        onClose={() => setResponse(null)}
        className="relative z-50"
      >
        <div className="fixed inset-0 bg-black/30" />
        <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
          <DialogPanel className="mx-auto w-100 rounded-lg p-10 bg-primary-50">
            <DialogTitle>Here are your credentials</DialogTitle>
            <Description className="py-4">
              <h4 className="mb-4">
                Do not forget to copy them, the secret will only be shown once!
              </h4>
              <label htmlFor="client_id">
                Client ID
                <input
                  id="client_id"
                  type="text"
                  className="rounded-lg w-full"
                  readOnly
                  value={response?.client_id}
                />
              </label>
              <label htmlFor="client_secret">
                Client secret
                <input
                  id="client_secret"
                  type="text"
                  className="rounded-lg w-full"
                  readOnly
                  value={response?.client_secret}
                />
              </label>
            </Description>

            <button
              type="submit"
              className="w-full button button-large button-light py-2 px-4 my-2"
              onClick={copyToClipboard}
            >
              <div className="button button-label">
                {isCopied ? 'Copied!' : 'Copy to clipboard'}
              </div>
            </button>
            <button
              type="submit"
              className="w-full button button-large button-dark py-2 px-4 my-2"
              onClick={() => navigate(-1)}
            >
              <div className="button button-label">OK</div>
            </button>
          </DialogPanel>
        </div>
      </Dialog>
      <div className="w-full max-w-[688px]">
        <h3 className="mb-5">Create API Credentials</h3>
        <Formik
          initialValues={{
            name: '',
          }}
          onSubmit={createCredentials}
        >
          <Form>
            <label htmlFor="email" className="text-sm my-4 block">
              <div className="w-full">Credentials name</div>
              <Field
                type="text"
                id="name"
                name="name"
                className="w-full
                  ircam-input"
              />
            </label>
            <div className="grid grid-cols-2 gap-2">
              <div className="my-4">
                <Link to={-1 as any}>
                  <div
                    className="w-full button button-large button-light py-2 px-4"
                    aria-disabled={loading}
                  >
                    <div className="button button-label text-center">
                      Cancel
                    </div>
                  </div>
                </Link>
              </div>

              <div className="my-4">
                <button
                  type="submit"
                  className="w-full button button-large button-dark py-2 px-4"
                  disabled={loading}
                >
                  <div className="button button-label">Create key pair</div>
                </button>
              </div>
            </div>
          </Form>
        </Formik>
      </div>
    </div>
  )
}
